import React from "react";
import "./adminHeader.scss";

export default function AdminHeader({ title, description, badgeText }) {
  return (
    <header className="admin-reusable-header fuel-fade-in">
      <div className="header-content-alignment-hub">
        {/* Dynamic Context Header Tag Line */}
        <div className="title-row-block">
          <h1>{title}</h1>
          {badgeText && (
            <span className="header-context-badge">{badgeText}</span>
          )}
        </div>

        {/* Descriptive Segment Narrative Info String */}
        {description && (
          <p className="header-narrative-subtitle">{description}</p>
        )}
      </div>
    </header>
  );
}
